import { render, staticRenderFns } from "./ConfirmPayment2.vue?vue&type=template&id=7b752e58&"
import script from "./ConfirmPayment2.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayment2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports